import React, { useContext, useState, useEffect, useRef } from 'react';
import {
  Button,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Nav,
  NavItem,
  Card,
  CardHeader,
  CardBody,
  UncontrolledTooltip,
  Popover,
  PopoverHeader,
  PopoverBody,
} from 'reactstrap';
import style from './AddFlexEventModal.style';
import { Link, useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheckSquare,
  faSquare,
  faUser,
  faInfoCircle,
  faExclamationCircle,
  faLink,
  faCog,
  faTag,
  faTags,
  faTimesCircle,
  faFilter,
} from '@fortawesome/free-solid-svg-icons';
import {
  clone,
  getEvaluatorColumn,
  getFlexEventsWithinTimeInterval,
  getTimeSlotsWithinTimeInterval,
} from '../../../../../../Services/schedule';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import { postDataAgnostic } from '../../../../../../Services/dataApi';
import { DepartmentContext } from '../../../../../../DepartmentWrapper';
import { useAuth0 } from '../../../../../../auth0/reactAuth0Spa';
import {
  checkLoginForError,
  formatBearerToken,
  formatMeetingUrlForDisplay,
  isRezrateEmbeddedMeetingUrl,
  REZRATE_EMBEDDED_MEETING_PLACEHOLDER,
  urlWithHttpProtocol,
} from '../../../../../../Common.functions';
import Swal from 'sweetalert2';
import tinycolor from 'tinycolor2';
import TagFilterPopover from 'Body/RezRATE/AdminLanding/AdminCandidates/TagFilterPopover/TagFilterPopover';
import { popoverModifiers } from 'enums';

// Initialize Day.js plugins
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

const AddFlexEventModal = ({
  candidates = [],
  columnTracker = [],
  dateIsInThePast,
  evaluators = [],
  fireConfirmationForEditingPastSchedule,
  forcedContext,
  indexedFlexEventEvaluators = [],
  isOpen,
  pk_InterviewDate,
  rowTracker = [],
  scheduleData,
  selectedCell,
  selectedTimeSlot,
  setShowAddFlexEventModal,
  setShowFlexEventDetailModal,
  updateAllData,
  willEditThePast,
}) => {
  const [EventName, setEventName] = useState('');
  const [StartDateTime, setStartDateTime] = useState();
  const [EndDateTime, setEndDateTime] = useState();

  const [Duration, setDuration] = useState();
  const [URLType, setURLType] = useState('AllDay');
  const [URL, setURL] = useState();
  const [customURL, setCustomURL] = useState();
  const [Details, setDetails] = useState();
  const [timeSlot, setTimeslot] = useState();

  const [isSubmitting, setIsSubmitting] = useState(false);

  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const [selectedEvaluators, setSelectedEvaluators] = useState([]);
  const [selectAllCandidates, setSelectAllCandidates] = useState(false);
  const [selectAllEvaluators, setSelectAllEvaluators] = useState(false);
  const [showTagFilterPopover, setShowTagFilterPopover] = useState(false);
  const [tagFilter, setTagFilter] = useState({ pk_Tag: null, Tag: 'All' });
  const [filteredCandidates, setFilteredCandidates] = useState([]);

  const timeOuts = {};

  const { metaData, body = [] } = scheduleData || {};
  const { DateOfInterview } = metaData || {};

  const history = useHistory();

  const deptContext = useContext(DepartmentContext);
  const dContext = forcedContext ? forcedContext : deptContext;
  const embeddedUiEnabled =
    dContext &&
    dContext.department &&
    dContext.department.VirtualMeetingMode === 'Internal' &&
    Boolean(dContext.department.enableEmbeddedMeetings);
  const { getTokenSilently, loginWithRedirect } = useAuth0();
  const mainRoomURL =
    scheduleData && scheduleData.metaData
      ? scheduleData.metaData.MainRoomURL || scheduleData.metaData.mainRoomURL || ''
      : '';
  const mainRoomURLDetails = scheduleData && scheduleData.metaData ? scheduleData.metaData.MainRoomURLDetails : '';

  const scheduleStartSlot =
    selectedTimeSlot && selectedTimeSlot !== 'all'
      ? JSON.parse(selectedTimeSlot).slot
      : body && body[0]
      ? body[0].slot
      : '';

  const scheduleStart = scheduleStartSlot ? dayjs(scheduleStartSlot) : null;

  const scheduleEndSlot =
    selectedTimeSlot && selectedTimeSlot !== 'all'
      ? JSON.parse(selectedTimeSlot).slotEnd
      : body && body[body.length - 1]
      ? body[body.length - 1].slotEnd
      : '';
  const scheduleEnd = scheduleEndSlot ? dayjs(scheduleEndSlot) : null;

  const firstTimeSlot = body && body[0] ? body[0] : null;

  const monthDate = DateOfInterview
    ? dayjs.tz(DateOfInterview).format('MMM DD, YYYY')
    : dayjs.tz().format('MMM DD, YYYY');

  useEffect(() => {
    if (isOpen) {
      clearFields();
    }

    if (isOpen) {
      if (selectedTimeSlot) {
        if (selectedTimeSlot !== 'all') {
          if (scheduleStart && scheduleEnd) {
            setStartDateTime(scheduleStart.format('hh:mm A'));
            setEndDateTime(scheduleEnd.format('hh:mm A'));
            setDuration(scheduleEnd.diff(scheduleStart, 'minutes'));
          }
        } else {
          if (firstTimeSlot) {
            const newStart = firstTimeSlot.slot ? dayjs(firstTimeSlot.slot) : null;
            const newEnd = firstTimeSlot.slotEnd ? dayjs(firstTimeSlot.slotEnd) : null;

            if (newStart && newEnd) {
              setStartDateTime(newStart.format('hh:mm A'));
              setEndDateTime(newEnd.format('hh:mm A'));
              setDuration(newEnd.diff(newStart, 'minutes'));
            }
          }
        }
      } else if (selectedCell) {
        const row = selectedCell ? selectedCell.row : timeSlot ? timeSlot : {};
        const { slot, slotEnd } = row || {};
        const newStart = slot ? dayjs(slot) : null;
        const newEnd = slotEnd ? dayjs(slotEnd) : null;

        if (newStart && newEnd) {
          setStartDateTime(newStart.format('hh:mm A'));
          setEndDateTime(newEnd.format('hh:mm A'));
          setDuration(newEnd.diff(newStart, 'minutes'));
        }
      }
    }
  }, [isOpen]);

  useEffect(() => {
    const newfilteredCandidates = candidates.filter((c) => {
      const { Tags = [] } = c;
      const isTagMatch = Tags.find((tag) => {
        return tagFilter == null || tagFilter.pk_Tag == null || tag.pk_Tag === tagFilter.pk_Tag;
      });

      return isTagMatch || tagFilter.pk_Tag == null;
    });

    setFilteredCandidates(newfilteredCandidates);
  }, [tagFilter, candidates]);

  const renderAssignError = () => {
    if (selectedCandidates.length <= 0 && selectedEvaluators.length <= 0) {
      return (
        <div style={{ color: 'red', fontSize: 12, fontWeight: 'normal', marginLeft: 10 }}>
          Must select at least 1 or more Evaluators or Candidates.
        </div>
      );
    }
  };

  const clearFields = () => {
    setEventName('');
    setStartDateTime();
    setEndDateTime();
    setDuration();
    setURLType('AllDay');
    setURL(mainRoomURL);
    setCustomURL(null);
    setDetails(mainRoomURLDetails);
    setSelectedCandidates([]);
    setSelectedEvaluators([]);
  };

  const renderFilterByTagButton = () => {
    return (
      <Button
        id="tags_popover"
        style={{ width: '100%' }}
        onClick={async () => {
          if (dateIsInThePast && !willEditThePast) {
            const continueProcess = await fireConfirmationForEditingPastSchedule();
            if (!continueProcess) {
              return;
            }
          }
          setShowTagFilterPopover(!showTagFilterPopover);
        }}
      >
        <div style={style.spaceBetweenRow}>
          <div
            style={{
              ...style.simpleColumn,
              width: 50,
              marginRight: 10,
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <FontAwesomeIcon icon={faTag} />
          </div>
          <div style={{ ...style.simpleColumn, width: '100%', justifyContent: 'center', alignItems: 'center' }}>
            {tagFilter.pk_Tag ? tagFilter.Tag : 'All'}
          </div>
          <div style={{ ...style.simpleColumn, width: 50, justifyContent: 'center', alignItems: 'center' }}>
            <FontAwesomeIcon icon={faFilter} />
          </div>
        </div>
        {renderTagFilterPopover()}
      </Button>
    );
  };

  const renderTagFilterPopover = () => {
    return (
      <Popover
        flip={false}
        trigger="legacy"
        target="tags_popover"
        placementPrefix={'tagFilter bs-popover'}
        modifiers={popoverModifiers}
        isOpen={showTagFilterPopover}
        // toggle={() => setShowTagFilterPopover(!showTagFilterPopover)}
      >
        <PopoverHeader>
          {' '}
          <div style={style.spaceBetweenRow}>
            <div style={style.buttonLabel}>Tag Filter</div>
            <div>
              <FontAwesomeIcon
                icon={faTimesCircle}
                style={style.clickable}
                onClick={() => {
                  setShowTagFilterPopover(false);
                }}
              />
            </div>
          </div>
        </PopoverHeader>
        <PopoverBody style={{ height: 200 }}>
          <TagFilterPopover
            tagFilter={tagFilter}
            setTagFilter={setTagFilter}
            setShowTagFilter={setShowTagFilterPopover}
          />
        </PopoverBody>
      </Popover>
    );
  };

  const renderTabContent = () => {
    const momentStart = StartDateTime ? dayjs(`${monthDate} ${StartDateTime}`) : null;
    const momentEnd = EndDateTime ? dayjs(`${monthDate} ${EndDateTime}`) : null;

    const slotsInInterval =
      scheduleData && momentStart && momentEnd
        ? getTimeSlotsWithinTimeInterval(scheduleData, StartDateTime, momentStart, momentEnd)
        : [];
    const candidatesInRow = [];
    const candidatesInSlotsInInterval = []; // list of entire Candidate objects, for marking Evaluators as busy or not.

    slotsInInterval.forEach((s) => {
      const candidates = rowTracker[s.pk_Timeslot];
      if (candidates && candidates.length > 0) {
        candidates.forEach((c) => {
          candidatesInRow.push(c);
        });
      }

      Object.keys(s).forEach((pk_ScheduleAssignment) => {
        if (s[pk_ScheduleAssignment] && s[pk_ScheduleAssignment].ScheduleBlockEntries) {
          s[pk_ScheduleAssignment].ScheduleBlockEntries.forEach((scheduleBlock) => {
            if (scheduleBlock.Candidates) {
              scheduleBlock.Candidates.forEach((c) => {
                candidatesInSlotsInInterval.push(c);
              });
            }
          });
        }
      });
    });

    return (
      <>
        <div style={{ ...style.simpleRow, fontWeight: 'bold' }}>Assign Users {renderAssignError()}</div>
        <div style={style.spaceBetweenRow}>
          <div style={{ ...style.simpleColumn, width: '49%' }}>
            <Card>
              <CardHeader>
                <div style={style.spaceBetweenRow}>
                  <div>
                    Candidates ({selectedCandidates.length}/{filteredCandidates.length})
                  </div>
                  <div>
                    <div style={style.spaceBetweenRow}>
                      <FontAwesomeIcon
                        icon={selectedCandidates.length == filteredCandidates.length ? faCheckSquare : faSquare}
                        style={{ fontSize: 24, marginRight: 10, marginLeft: 30, cursor: 'pointer' }}
                        onClick={() => {
                          toggleSelectAll('candidates');
                        }}
                      />
                      <div style={{ fontWeight: 'bold' }}>All</div>
                    </div>
                  </div>
                </div>
              </CardHeader>
              <CardBody style={{ padding: 5, paddingBottom: 10 }}>
                <div>
                  <div style={{ ...style.simpleRow, marginBottom: 5 }}>{renderFilterByTagButton()}</div>
                  <div style={style.simpleRow}>
                    <div style={{ ...style.simpleColumn, height: 'calc(100vh - 350px)', overflowY: 'scroll' }}>
                      {filteredCandidates.map((c) => {
                        const { pk_Candidate, PhotoUrl, Tags = [] } = c;
                        const isBusy = candidatesInRow.includes(pk_Candidate);
                        const isSelected = selectedCandidates.includes(pk_Candidate);
                        const borderColor = isBusy ? '#f55c5c' : null;
                        const backgroundColor = isSelected ? '#d9f5ff' : c.color;
                        const id = `candidate_${pk_Candidate}`;
                        const isTagMatch = Tags.find((tag) => {
                          return tagFilter == null || tagFilter.pk_Tag == null || tag.pk_Tag === tagFilter.pk_Tag;
                        });

                        let tagString = 'Tags: ';

                        Tags.forEach((tag, index) => {
                          tagString += tag.Tag;
                          if (index < Tags.length - 1) {
                            tagString += ', ';
                          }
                        });

                        if (!isTagMatch && tagFilter.pk_Tag != null) {
                          return;
                        }
                        return (
                          <div
                            key={id}
                            id={id}
                            style={{
                              ...style.simpleRow,
                              backgroundColor: backgroundColor,
                              cursor: 'pointer',
                              border: isBusy ? `3px solid ${borderColor}` : null,
                              color: tinycolor(backgroundColor).isLight() ? 'black' : 'white',

                              alignItems: 'center',
                              paddingTop: 10,
                              paddingBottom: 10,
                            }}
                            onClick={() => {
                              const newSelectedCandidates = selectedCandidates.slice();
                              if (isSelected) {
                                newSelectedCandidates.splice(selectedCandidates.indexOf(pk_Candidate), 1);
                              } else {
                                newSelectedCandidates.push(pk_Candidate);
                              }
                              setSelectedCandidates(newSelectedCandidates);
                            }}
                          >
                            <div style={{ ...style.simpleColumn, width: 50 }}>
                              <div style={{ ...style.simpleRow, alignItems: 'center', justifyContent: 'center' }}>
                                <FontAwesomeIcon
                                  icon={isSelected ? faCheckSquare : faSquare}
                                  style={{ cursor: 'pointer', fontSize: 20 }}
                                />
                              </div>
                            </div>
                            <div style={{ ...style.simpleColumn, width: 50, marginRight: 10 }}>
                              {PhotoUrl ? (
                                <img
                                  src={PhotoUrl}
                                  width={50}
                                  height={50}
                                  style={{ borderRadius: 25, objectFit: 'cover' }}
                                />
                              ) : (
                                <FontAwesomeIcon icon={faUser} style={{ fontSize: 35 }} />
                              )}
                            </div>
                            <div style={{ ...style.simpleColumn }}>
                              <div style={{ ...style.simpleRow, alignItems: 'center' }}>
                                <div> {`${c.LastName}, ${c.FirstName}`}</div>
                                {/* {Tags.length > 0 ? (
                                  <FontAwesomeIcon
                                    icon={Tags.length > 1 ? faTags : faTag}
                                    style={{ marginLeft: 5, marginTop: 5 }}
                                  />
                                ) : null} */}
                              </div>
                              {Tags.length > 0 ? (
                                <div
                                  style={{ ...style.simpleRow, alignItems: 'center', fontSize: 9, fontWeight: 'bold' }}
                                >
                                  {tagString}
                                </div>
                              ) : null}
                            </div>

                            {isBusy ? (
                              <div>
                                <FontAwesomeIcon
                                  id={`alert_icon_${pk_Candidate}`}
                                  icon={faExclamationCircle}
                                  style={{ marginRight: 10, marginLeft: 10, cursor: 'pointer' }}
                                />
                                <UncontrolledTooltip target={`alert_icon_${pk_Candidate}`}>
                                  Candidate is Scheduled for Interview sometime between the start and end time!
                                </UncontrolledTooltip>
                              </div>
                            ) : null}

                            {/* {Tags.length > 0 ? (
                              <UncontrolledTooltip target={'candidate_' + pk_Candidate}>
                                {tagString}
                              </UncontrolledTooltip>
                            ) : null} */}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>
          <div style={{ ...style.simpleColumn, width: '49%' }}>
            <Card>
              <CardHeader>
                <div style={style.spaceBetweenRow}>
                  <div>
                    Evaluators ({selectedEvaluators.length}/{evaluators.length})
                  </div>
                  <div>
                    <div style={style.spaceBetweenRow}>
                      <FontAwesomeIcon
                        icon={selectedEvaluators.length == evaluators.length ? faCheckSquare : faSquare}
                        style={{ fontSize: 24, marginRight: 10, marginLeft: 30, cursor: 'pointer' }}
                        onClick={() => {
                          toggleSelectAll('evaluators');
                        }}
                      />
                      <div style={{ fontWeight: 'bold' }}>All</div>
                    </div>
                  </div>
                </div>
              </CardHeader>
              <CardBody style={{ padding: 5, paddingBottom: 10 }}>
                <div>
                  <div style={{ ...style.simpleColumn, height: 'calc(100vh - 307px)', overflowY: 'scroll' }}>
                    {evaluators.map((e) => {
                      const { pk_User, UserPhotoUrl } = e;
                      const { metaData = {} } = scheduleData;
                      const { FlexEvents = [] } = metaData;
                      const isSelected = selectedEvaluators.includes(pk_User);
                      const flexEventsInInterval = e.FlexEvents
                        ? getFlexEventsWithinTimeInterval(
                            [...e.FlexEvents, ...FlexEvents],
                            StartDateTime,
                            momentStart,
                            momentEnd,
                          )
                        : [];
                      let isBusy = false;
                      if (e.FlexEvents) {
                        let index = 0;
                        while (index < e.FlexEvents.length && !isBusy) {
                          const flexEvent = e.FlexEvents[index];
                          const exists = flexEventsInInterval.find((f) => {
                            return f.pk_FlexEvent === flexEvent.pk_FlexEvent;
                          });

                          if (exists) {
                            isBusy = true;
                          }
                          index++;
                        }
                      }

                      if (!isBusy) {
                        const evaluatorColumn = getEvaluatorColumn(scheduleData, e);
                        if (evaluatorColumn) {
                          if (
                            candidatesInSlotsInInterval.find((c) => {
                              return c.fk_ScheduleAssignment === evaluatorColumn.pk_ScheduleAssignment;
                            })
                          ) {
                            isBusy = true;
                          }
                        }
                      }

                      return (
                        <div
                          key={'evaluator_' + pk_User}
                          style={{
                            ...style.simpleRow,
                            backgroundColor: isSelected ? '#d9f5ff' : 'white',
                            border: isBusy ? '3px solid #f55c5c' : null,
                            alignItems: 'center',
                            paddingTop: 10,
                            paddingBottom: 10,
                            cursor: 'pointer',
                          }}
                          onClick={() => {
                            const newSelectedEvaluators = selectedEvaluators.slice();
                            if (isSelected) {
                              newSelectedEvaluators.splice(selectedEvaluators.indexOf(pk_User), 1);
                            } else {
                              newSelectedEvaluators.push(pk_User);
                            }
                            setSelectedEvaluators(newSelectedEvaluators);
                          }}
                        >
                          <div style={{ ...style.simpleColumn, width: 50 }}>
                            <div style={{ ...style.simpleRow, alignItems: 'center', justifyContent: 'center' }}>
                              <FontAwesomeIcon icon={isSelected ? faCheckSquare : faSquare} style={{ fontSize: 20 }} />
                            </div>
                          </div>
                          <div style={{ ...style.simpleColumn, width: 50, marginRight: 10 }}>
                            {UserPhotoUrl ? (
                              <img
                                src={UserPhotoUrl}
                                width={50}
                                height={50}
                                style={{ borderRadius: 25, objectFit: 'cover' }}
                              />
                            ) : (
                              <FontAwesomeIcon icon={faUser} style={{ fontSize: 35 }} />
                            )}
                          </div>
                          <div style={{ ...style.simpleColumn }}>{`${e.UserLast}, ${e.UserFirst}`}</div>
                          {isBusy ? (
                            <div>
                              <FontAwesomeIcon
                                id={`alert_icon_${pk_User}`}
                                icon={faExclamationCircle}
                                style={{ marginRight: 10, marginLeft: 10, cursor: 'pointer' }}
                              />
                              <UncontrolledTooltip target={`alert_icon_${pk_User}`}>
                                Evaluator is Scheduled for a candidate Interview or an Event sometime between the start
                                and end time!
                              </UncontrolledTooltip>
                            </div>
                          ) : null}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>
        </div>
        <div style={{ ...style.simpleRow, marginTop: 10 }}>
          <div style={{ ...style.simpleColumn, height: '100%', overflowY: 'scroll' }}></div>
        </div>
      </>
    );
  };

  const saveEvent = () => {
    if (!checkEventErrors()) {
      return;
    }

    const pathExploded = history.location.pathname.split('/');
    const scheduleID = pathExploded[pathExploded.length - 1];
    const monthDate = DateOfInterview
      ? dayjs.tz(DateOfInterview).format('MMM DD, YYYY')
      : dayjs.tz().format('MMM DD, YYYY');

    const event = {
      EventName,
      EnableForAllUsers: false,
      EnableAbsoluteTime: true,
      EnableForAllCandidates: false,
      CustomUrl:
        !embeddedUiEnabled && isRezrateEmbeddedMeetingUrl(URL)
          ? null
          : isRezrateEmbeddedMeetingUrl(URL)
          ? REZRATE_EMBEDDED_MEETING_PLACEHOLDER
          : URL
          ? urlWithHttpProtocol(URL)
          : null,
      UrlType: embeddedUiEnabled ? URLType : URLType === 'Embedded' ? 'Custom' : URLType,
      CustomUrlDescription: Details,
    };

    const momentStart = StartDateTime ? dayjs(`${monthDate} ${StartDateTime}`) : dayjs();
    const momentEnd = EndDateTime ? dayjs(`${monthDate} ${EndDateTime}`) : dayjs();
    event.FlexTimeStart = momentStart.format('HH:mm:ss');
    event.FlexDateStart = momentStart.format('YYYY-MM-DD');

    event.FlexTimeEnd = momentEnd.format('HH:mm:ss');
    event.FlexDateEnd = momentEnd.format('YYYY-MM-DD');
    // EndDateTime
    event.StartDateTime = momentStart.toISOString();
    event.EndDateTime = momentEnd.toISOString();

    getTokenSilently()
      .then((token) => {
        postDataAgnostic(
          'department/season/schedule/flexEvent',
          {
            pk_Department: dContext.department.pk_Department,
            pk_InterviewDate: pk_InterviewDate ? pk_InterviewDate : parseInt(scheduleID),
          },
          {
            payload: [{ event, evaluators: selectedEvaluators || [], candidates: selectedCandidates || [] }],
          },
          formatBearerToken(token),
        )
          .then((res) => {
            updateAllData();
            setShowAddFlexEventModal(false);
            setShowFlexEventDetailModal(false);
            setIsSubmitting(false);
          })
          .catch((err) => {
            setIsSubmitting(false);
          });
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const isValid = () => {
    return (
      EventName &&
      EventName.toLowerCase() !== 'unavailable' &&
      (selectedCandidates.length > 0 || selectedEvaluators.length > 0) &&
      StartDateTime &&
      EndDateTime &&
      checkFieldValidity('Time Start').isValid &&
      checkFieldValidity('Time End').isValid
    );
  };

  const toggleSelectAll = (type) => {
    if (type === 'candidates') {
      if (selectedCandidates.length != 0 && selectedCandidates.length === candidates.length) {
        setSelectAllCandidates(false);
        setSelectedCandidates([]);
      } else {
        const newSelectedCandidates = [];
        candidates.forEach((c) => {
          if (!newSelectedCandidates.includes(c.pk_Candidate)) {
            newSelectedCandidates.push(c.pk_Candidate);
          }
        });
        setSelectAllCandidates(true);
        setSelectedCandidates(newSelectedCandidates);
      }
    } else {
      if (selectedEvaluators.length != 0 && selectedEvaluators.length === evaluators.length) {
        setSelectAllEvaluators(false);
        setSelectedEvaluators([]);
      } else {
        const newSelectedEvaluators = [];
        evaluators.forEach((e) => {
          if (!newSelectedEvaluators.includes(e.pk_User)) {
            newSelectedEvaluators.push(e.pk_User);
          }
        });
        setSelectAllEvaluators(true);
        setSelectedEvaluators(newSelectedEvaluators);
      }
    }
  };

  // For lighting up invalid feedback text
  const checkFieldValidity = (field) => {
    let type = 'beyond_other';
    let isValid = true;
    const { metaData, body = [] } = scheduleData || {};
    const timeStartSlot = body && body[0] ? body[0].slot : '';
    const timeStart = timeStartSlot ? dayjs(timeStartSlot) : null;
    const timeEndSlot = body && body[body.length - 1] ? body[body.length - 1].slotEnd : '';
    const timeEnd = timeEndSlot ? dayjs(timeEndSlot) : null;

    // if (body && body[body.length - 1]) {
    //   const lastTimeSlot = body[body.length - 1];
    //   if (lastTimeSlot.CustomDurationInMinutes) {
    //     timeEnd.add(lastTimeSlot.CustomDurationInMinutes, 'minutes');
    //   } else {
    //     timeEnd.add(metaData.StandardDurationInMinutes, 'minutes');
    //   }

    //   if (lastTimeSlot.CustomPassingDurationInMinutes) {
    //     timeEnd.add(lastTimeSlot.CustomPassingDurationInMinutes, 'minutes');
    //   } else {
    //     timeEnd.add(metaData.StandardPassingDurationInMinutes, 'minutes');
    //   }
    // }
    switch (field) {
      case 'Title':
        return EventName != null && EventName && EventName.toLowerCase() !== 'unavailable';
      case 'Time Start':
        if (StartDateTime != null && EndDateTime != null && timeStart) {
          const startMoment = dayjs(`${monthDate} ${StartDateTime}`);
          const endMoment = dayjs(`${monthDate} ${EndDateTime}`);
          isValid = startMoment.isSameOrBefore(endMoment) && startMoment.isSameOrAfter(timeStart);

          if (!startMoment.isSameOrAfter(timeStart)) {
            type = 'out_of_bounds';
          }
        } else {
          isValid = false;
        }

        return { isValid, type };
      case 'Time End':
        if (EndDateTime != null && StartDateTime != null && timeEnd) {
          const endMoment = dayjs(`${monthDate} ${EndDateTime}`);
          const startMoment = dayjs(`${monthDate} ${StartDateTime}`);

          isValid = endMoment.isSameOrBefore(timeEnd) && endMoment.isSameOrAfter(startMoment);

          if (!endMoment.isSameOrBefore(timeEnd)) {
            type = 'out_of_bounds';
          }
        } else {
          isValid = false;
        }
        return { isValid, type };
    }
  };

  // For popping erorr alerts.
  const checkEventErrors = () => {
    if (StartDateTime && EndDateTime) {
      const startMoment = dayjs(`${monthDate} ${StartDateTime}`);
      const endMoment = dayjs(`${monthDate} ${EndDateTime}`);

      if (startMoment.isAfter(endMoment)) {
        Swal.fire('Invalid Time Values!', 'Time End is earlier than Time Start. Fix before Saving!', 'error');
        return false;
      }
    }

    return true;
  };

  const timeStartSlot = body && body[0] ? body[0].slot : '';
  const timeStart = timeStartSlot ? dayjs(timeStartSlot) : null;
  const timeEndSlot = body && body[body.length - 1] ? body[body.length - 1].slotEnd : '';
  const timeEnd = timeEndSlot ? dayjs(timeEndSlot) : null;

  const useAllDayLink = URLType === 'AllDay';
  const useCustomLink = URLType === 'Custom';
  const useEmbeddedLink = embeddedUiEnabled && URLType === 'Embedded';

  return (
    <Modal
      isOpen={isOpen}
      centered={true}
      style={{ minWidth: '80vw' }}
      onClosed={() => {
        clearFields();
      }}
    >
      <ModalHeader
        closeButton
        toggle={() => {
          setShowAddFlexEventModal(false);
        }}
      >
        <div style={{ ...style.spaceBetweenRow, width: '73vw' }}>
          <div>Add Flex Event</div>
        </div>
      </ModalHeader>
      <ModalBody>
        <div style={style.spaceBetweenRow}>
          <div style={{ ...style.simpleColumn, width: '39%' }}>
            <div style={{ ...style.simpleRow, marginBottom: 10 }}>
              <div style={style.simpleColumn}>
                <Label>Title</Label>
                <Input
                  invalid={!checkFieldValidity('Title')}
                  defaultValue={EventName}
                  placeholder="Flex Event Title"
                  name="title"
                  onChange={(e) => {
                    const newValue = e.target.value;
                    if (timeOuts.title) {
                      clearTimeout(timeOuts.title);
                    }

                    timeOuts.title = setTimeout(() => {
                      setEventName(newValue);
                    }, 300);
                  }}
                />
                <FormFeedback invalid={!checkFieldValidity('Title')}>
                  Invalid Event name! Cannot be empty or 'UNAVAILABLE'.
                </FormFeedback>
              </div>
            </div>

            <div style={{ ...style.spaceBetweenRow, marginBottom: 10 }}>
              <div style={{ ...style.simpleColumn, width: '49%' }}>
                <Label>Time Start</Label>
                <Input
                  invalid={!checkFieldValidity('Time Start').isValid}
                  value={StartDateTime ? dayjs(`${monthDate} ${StartDateTime}`).format('HH:mm') : ''}
                  type="time"
                  name="timeStart"
                  onChange={(e) => {
                    const newMomentEnd = Duration
                      ? dayjs(`${monthDate} ${e.target.value}`).add(Duration, 'minutes')
                      : dayjs(`${monthDate} ${e.target.value}`);

                    setEndDateTime(newMomentEnd.format('hh:mm A'));
                    setStartDateTime(e.target.value);
                    setTimeslot('custom');
                  }}
                />
                <FormFeedback invalid={!checkFieldValidity('Time Start').isValid}>
                  {checkFieldValidity('Time Start').type === 'beyond_other'
                    ? `Start Time MUST be equal to or before ${
                        EndDateTime ? dayjs(`${monthDate} ${EndDateTime}`).format('hh:mm A') : ''
                      }`
                    : `Start Time MUST be equal to or after ${timeStart ? timeStart.format('hh:mm A') : ''}`}
                </FormFeedback>
              </div>
              <div style={{ ...style.simpleColumn, width: '49%' }}>
                <Label for="title">Time End</Label>
                <Input
                  invalid={!checkFieldValidity('Time End').isValid}
                  value={EndDateTime ? dayjs(`${monthDate} ${EndDateTime}`).format('HH:mm') : ''}
                  type="time"
                  name="timeEnd"
                  onChange={(e) => {
                    if (StartDateTime) {
                      const momentStart = dayjs(`${monthDate} ${StartDateTime}`);
                      const momentEnd = dayjs(`${monthDate} ${e.target.value}`);
                      let newDuration = momentEnd.diff(momentStart, 'minutes');
                      if (newDuration < 0) {
                        newDuration = 0;
                      }
                      setDuration(newDuration);
                    }
                    setEndDateTime(e.target.value);
                    setTimeslot('custom');
                  }}
                />
                <FormFeedback invalid={!checkFieldValidity('Time End').isValid}>
                  {checkFieldValidity('Time End').type === 'beyond_other'
                    ? `End Time MUST be equal to or after ${
                        StartDateTime ? dayjs(`${monthDate} ${StartDateTime}`).format('hh:mm A') : ''
                      }`
                    : `End Time MUST be equal to or before ${timeEnd ? timeEnd.format('HH:mm') : ''}`}
                </FormFeedback>
              </div>
            </div>

            <div style={{ ...style.simpleRow, marginBottom: 10 }}>
              <div style={style.simpleColumn}>
                <Label>Duration (minutes)</Label>
                <Input
                  value={Duration}
                  type="number"
                  placeholder="Duration"
                  name="title"
                  onChange={(e) => {
                    const newDuration = Math.abs(parseInt(e.target.value));
                    if (StartDateTime) {
                      const momentStart = dayjs(`${monthDate} ${StartDateTime}`);
                      const newEndTime = momentStart.add(newDuration, 'minutes');
                      setEndDateTime(newEndTime.format('HH:mm'));
                    }
                    setDuration(newDuration);
                    setTimeslot('custom');
                  }}
                />
              </div>
            </div>

            <div style={style.simpleRow}>
              <div style={{ ...style.simpleColumn, width: 50 }}>URL:</div>
              <div style={{ ...style.simpleColumn, width: '100%' }}></div>
            </div>

            <div
              style={{ ...style.simpleRow, cursor: 'pointer' }}
              onClick={async (e) => {
                e.stopPropagation();

                setURLType('AllDay');
                setURL(mainRoomURL);
                setDetails(mainRoomURLDetails);
              }}
            >
              <div style={{ ...style.simpleColumn, width: 50, marginBottom: 0, marginTop: 4 }}>
                <Input
                  type="radio"
                  name="flexEventUrlType"
                  checked={useAllDayLink}
                  onChange={async (e) => {
                    e.stopPropagation();
                    setURLType('AllDay');
                    setURL(mainRoomURL);
                    setDetails(mainRoomURLDetails);
                  }}
                />
              </div>
              <div style={{ ...style.simpleColumn, width: 200 }}>
                <div style={style.simpleRow}>
                  Same as All Day Meeting
                  <FontAwesomeIcon
                    id={`useAllDayMeetingLabel`}
                    icon={faInfoCircle}
                    style={{ marginTop: 4, marginLeft: 5 }}
                  />
                  <UncontrolledTooltip target={`useAllDayMeetingLabel`}>
                    {' '}
                    Use the All Day Meeting link for this flex event.
                  </UncontrolledTooltip>
                </div>
              </div>
            </div>
            <div
              style={{
                ...style.simpleRow,
                paddingLeft: 45,
                marginBottom: 10,
              }}
            >
              {mainRoomURL ? (
                <Input
                  type="textarea"
                  invalid={useAllDayLink && !mainRoomURL}
                  rows={2}
                  disabled
                  value={formatMeetingUrlForDisplay(mainRoomURL)}
                  placeholder={'No Main Room URL. . .'}
                />
              ) : (
                <div
                  style={{
                    ...style.simpleColumn,
                    width: '100%',
                    backgroundColor: '#e9ecef',
                    border: `1px solid ${useAllDayLink ? `red` : '#ced4da'}`,
                    color: '#495057',
                    borderRadius: 5,
                    paddingLeft: 10,
                    height: 80,
                  }}
                >
                  <div>Missing All Day Meeting Link!</div>
                  <div style={{ ...style.simpleRow, alignItems: 'stretch', height: 40 }}>
                    <span style={{ marginRight: 0 }}>
                      {`The All Day Meeting Link can be configured by clicking the `}
                      <span style={{ display: 'inline-flex', alignItems: 'center', width: 20 }}>
                        <FontAwesomeIcon icon={faLink} />
                        <span style={{ position: 'relative' }}>
                          <FontAwesomeIcon
                            icon={faCog}
                            style={{ position: 'absolute', fontSize: 10, left: -6, top: 3, color: 'inherit' }}
                          />
                        </span>
                      </span>
                      {` button above schedule. . .`}
                    </span>
                  </div>
                </div>
              )}
            </div>

            {embeddedUiEnabled ? (
              <>
                <div
                  style={{ ...style.simpleRow, cursor: 'pointer' }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setURLType('Embedded');
                    setURL(REZRATE_EMBEDDED_MEETING_PLACEHOLDER);
                    setCustomURL(REZRATE_EMBEDDED_MEETING_PLACEHOLDER);
                    if (!Details || `${Details}`.trim() === '') {
                      setDetails('RezRATE will generate embedded meetings automatically as needed.');
                    }
                  }}
                >
                  <div style={{ ...style.simpleColumn, width: 50, marginBottom: 0, marginTop: 4 }}>
                    <Input
                      type="radio"
                      name="flexEventUrlType"
                      checked={useEmbeddedLink}
                      onChange={(e) => {
                        e.stopPropagation();
                        setURLType('Embedded');
                        setURL(REZRATE_EMBEDDED_MEETING_PLACEHOLDER);
                        setCustomURL(REZRATE_EMBEDDED_MEETING_PLACEHOLDER);
                        if (!Details || `${Details}`.trim() === '') {
                          setDetails('RezRATE will generate embedded meetings automatically as needed.');
                        }
                      }}
                    />
                  </div>
                  <div style={{ ...style.simpleColumn, width: 220 }}>
                    <div style={style.simpleRow}>
                      Use Embedded Meeting (Unique)
                      <FontAwesomeIcon
                        id="useEmbeddedFlexLabel"
                        icon={faInfoCircle}
                        style={{ marginTop: 4, marginLeft: 5 }}
                      />
                      <UncontrolledTooltip target={`useEmbeddedFlexLabel`}>
                        {' '}
                        Generate a unique RezRATE managed embedded meeting for this flex event.
                      </UncontrolledTooltip>
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    ...style.simpleRow,
                    paddingLeft: 45,
                    marginBottom: 10,
                  }}
                >
                  <Input
                    type="textarea"
                    rows={2}
                    disabled
                    value={formatMeetingUrlForDisplay(REZRATE_EMBEDDED_MEETING_PLACEHOLDER)}
                  />
                </div>
              </>
            ) : null}

            <div style={{ ...style.simpleRow, marginBottom: 10 }}>
              <div style={{ ...style.simpleColumn, width: '100%' }}>
                <div
                  style={{ ...style.simpleRow, cursor: 'pointer' }}
                  onClick={async (e) => {
                    e.stopPropagation();
                    setURL(customURL);
                    setURLType('Custom');
                  }}
                >
                  <div style={{ ...style.simpleColumn, width: 50, marginBottom: 0, marginTop: 4 }}>
                    <Input
                      type="radio"
                      name="flexEventUrlType"
                      checked={useCustomLink}
                      onChange={(e) => {
                        e.stopPropagation();
                        setURL(customURL);
                        setURLType('Custom');
                      }}
                    />
                  </div>
                  <div style={{ ...style.simpleColumn, width: 200 }}>
                    <div style={style.simpleRow}>
                      Use Custom Meeting Link
                      <FontAwesomeIcon
                        id="useCustomLinkLabel"
                        icon={faInfoCircle}
                        style={{ marginTop: 4, marginLeft: 5 }}
                      />
                      <UncontrolledTooltip target={`useCustomLinkLabel`}>
                        {' '}
                        Use a unique link for this meeting
                      </UncontrolledTooltip>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style={{ ...style.simpleRow, paddingLeft: 45, marginBottom: 10 }}>
              <Input
                type="textarea"
                invalid={useCustomLink && !customURL}
                disabled={!useCustomLink}
                name="text"
                placeholder="Enter Custom Link. . ."
                value={customURL}
                onChange={(e) => {
                  const newURL = e.target.value;
                  setURL(newURL);
                  setCustomURL(newURL);
                }}
              />
            </div>
            <div style={{ ...style.simpleRow, paddingLeft: 45 }}>
              <Input
                disabled={!useCustomLink}
                rows={5}
                type="textarea"
                value={Details}
                placeholder="Details"
                onChange={(e) => {
                  setDetails(e.target.value);
                }}
              />
            </div>
          </div>
          <div style={{ ...style.simpleColumn, width: '59%' }}>{renderTabContent()}</div>
        </div>
        <div style={{ ...style.simpleRow, alignItems: 'center', justifyContent: 'center', marginTop: 20 }}>
          <Button disabled={!isValid()} color="success" style={{ width: 150 }} onClick={saveEvent}>
            Save
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default AddFlexEventModal;
